var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rp-tips"},[_c('p',[_vm._v("本地最新成交参考价")]),_vm._v(" "),_c('span',[_vm._v("提交后可见")])])}]

export { render, staticRenderFns }